import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'

const OfferBanner = (props) => ( 
	<Container_s fluid>
		<Container_1000>
			{/*<h3>March Special - FREE SHIPPING!</h3>*/}
		
			{/*
			<p>Special Offer!</p>
			<h3>Spend $100 = Free Candle</h3>
			<Link to="/Offers">
				<i>details</i>
			</Link>
			*/}

			<h3>No new orders will be shipped until October 1, 2020 due to moving locations. Thank you!</h3>
		
		</Container_1000>
	</Container_s>
);

export default OfferBanner;


const Container_s = styled(Container)`
	height: 50px;
	padding: 0!important;
	background-color: #996633;
`;

const Container_1000 = styled(Container)`
	height: 100%;
	width: 100%!important;
	margin: 0 auto;
	padding: 5px 10px 0 10px!important;
	background-color: #996633;
	font-family: 'Raleway';
	font-size: 13px;
	color: white;
	text-align: center;

	p {
		display: inline;

	}
	h3 {
		display: inline;
		margin-left: 10px;
		font-size: 17px;
		font-weight: bold;
		line-height: 20px;
	}
	a {
		display: block;
		color: white;
		font-size: 12px;
		:hover {
			text-decoration: underline;
			color: white;
		}
	}

	${media.lg` 
		p {font-size: 14px;}
		h3 {font-size: 18px;}
		a {font-size: 13px;}
	`}
	${media.xxl` 
		p {font-size: 16px;}
		h3 {font-size: 20px;}
		a {font-size: 14px;}
	`}



`;


// WEBPACK FOOTER //
// ./src/components/OfferBanner.js